/* eslint-disable @typescript-eslint/no-require-imports */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { Language } from './utils/constants'

const Resources = {
  [Language.EN]: 'en.json',
  [Language.ES]: 'es.json',
  [Language.PT]: 'pt_BR.json'
}

const getResource = async (language: Language) => {
  try {
    const translation = await require(`../public/locales/${Resources[language]}`)

    return { [language]: { translation } }
  } catch {
    return void 0
  }
}

export const i18nInit = async (language: Language) => {
  return i18n.use(initReactI18next).init({
    resources: {
      ...(await getResource(language)),
      ...(await getResource(Language.PT))
    },
    lng: language,
    load: 'currentOnly',
    fallbackLng: [Language.EN, Language.PT],
    interpolation: {
      escapeValue: false
    },
    returnNull: false,
    returnEmptyString: false
  })
}

export default i18n

const t = i18n.t.bind(i18n)
export { t }
